/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#LINEITEM-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#LINEITEM-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#LINEITEM-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.pict.AppData.SelectedLineItem.ItemCode || 'N/A',
				this.pict.AppData.SelectedLineItem.Name || ('Unnamed LineItem #' + this.pict.AppData.SelectedLineItem.IDLineItem),
			);
		}
		else
		{
			tmpDisplayTemplate = this.pict.AppData.SelectedLineItem.Name || ('Unnamed LineItem #' + this.pict.AppData.SelectedLineItem.IDLineItem);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), go fetch the LineItem for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the LineItem record yet, get it and store it
			if (!this.pict.AppData.SelectedLineItem)
			{
				const tmpResult = await this.pict.providers.LineItemProvider.getLineItemByID(pValue);
				this.pict.AppData.SelectedLineItem = tmpResult;
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
		return true;
	}
}

module.exports = CustomInputHandler;
